import { render, staticRenderFns } from "./repsol-dialog-ok.component.html?vue&type=template&id=17016bfc&external"
import script from "./RepsolDialogOkComponent.vue?vue&type=script&lang=ts"
export * from "./RepsolDialogOkComponent.vue?vue&type=script&lang=ts"
import style0 from "./repsol-dialog-ok.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports